module.exports = "https://health.dajiuxing.com.cn/img/assets/login/Healthicon.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Flogin%2FHealthicon.png
// module id = GlFA
// module chunks = 93